import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { VersionHttp } from '../data-access/http/version.http'

@Injectable({
  providedIn: 'root',
})
export class VersionDomain {
  private readonly versionHttp = inject(VersionHttp)

  getBackendVersion(): Observable<string> {
    return this.versionHttp.getVersionBackend()
  }
}
